module.exports = __webpack_public_path__ + "img/4-on.296a081b.png";